export enum TableSettingsKeys {
  ANCHOR = 'anchor',
  COLUMNS = 'columns',
  DETAIL_DISPLAY = 'detailDisplay',
  FILTERS = 'filters', // Not Implemented (only save in settings)
  GROUP = 'group',
  INDEX = 'index',
  OPEN_GROUP = 'open-group',
  RESIZE_BOX = 'resizeBox',
  ROW_HEIGHT = 'rowHeight',
  SHOW_TOTAL = 'showTotal',
  STEP_COUNT = 'stepCount',
  TABLE_HEADER = 'tableHeader',
  TABLE_SORT = 'tableSort',
  VIEWS = 'views', // Not stored in view settings, used to save all views settings
  CURRENT_VIEW_ID = 'currentViewId', // Not stored in view settings, used to track the current view ID
  RESIZE_BOX_WRAPPER = 'resizeBoxWrapper',
}
